<template lang="pug">
img.my-logo(:src="logoPath", v-if="logoPath")
</template>

<script>
export default {
  props: ["logo"],
  data() {
    return {
      mediaHost: process.env.VUE_APP_MEDIAHOST,
    };
  },
  computed: {
    logoPath() {
      if (this.logo) return this.mediaHost + this.logo;
      return null;
    },
  },
};
</script>

<style lang="sass" scoped>
.my-logo
  position: absolute
  top: -50px
  width: 100px
  height: 100px
  border-radius: 6px
  overflow: hidden
  object-fit: cover
  box-shadow: 0.3em 0.3em 1em rgba(0,0,0,0.3)
</style>
